<template>
  <b-select placeholder="Выберите блюдо" expanded v-model="selectedDish">
    <option v-for="dish in dishes"
            :value="dish.id"

            :key="dish.id"
    >
      {{ dish.name }} ({{ dish.group }})
    </option>
  </b-select>
</template>

<script>

import dishRepository from "../../repository/dishRepository";

export default {
  props: ['dish'],
  data() {
    return {
      dishes: [],
    }
  },
  computed: {
    selectedDish: {
      get() {
        return this.dish;
      },
      set(value) {
        this.$emit('update:dish', value)
      }
    },
  },
  methods: {
    fetchData() {
      dishRepository.list()
          .then(({data}) => {
            this.dishes = data;
          })
    },
  },
  mounted() {
    this.fetchData()
  }
}
</script>

<style scoped>

</style>